import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import {
  Grid,
  GridColumn,
  GridDetailRow,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import * as React from "react";
import { toastr } from "react-redux-toastr";
import { NavLink } from "react-router-dom";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskViews.scss";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import TaskTitle from "./TaskTitle";
import TaskStatus from "./TaskStatus";
import TaskOwner from "./TaskOwner";
import TaskAlertDescription from "./TaskAlertDescription";
import TaskAlertStakeholders from "./TaskAlertStakeholders";
import TaskDelayConsequence from "./TaskDelayConsequence";
import TaskProximityAlertDate from "./TaskProximityAlertDate";
import TaskActualCompDate from "./TaskActualCompDate";
import TaskProjectedComDate from "./TaskProjectedComDate";
import TaskOriginalCompDate from "./TaskOriginalCompDate";
import TaskPercentageCompletion from "./TaskPercentageCompletion";
import TaskPercentageOnTrack from "./TaskPercentageOnTrack";
import TaskEffort from "./TaskEffort";
import TaskCost from "./TaskCost";
import TaskDescription from "./TaskDescription";
import TaskApproved from "./TaskApproved";
import TaskActionRegisterFormView from "./TaskActionRegisterFormView";
import PriorityRank from "./PriorityRank";
import moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import { mapTree } from "@progress/kendo-react-treelist";
import TaskActivityProgressPopup from "./TaskActivityProgressPopup";

export class TaskActionExpandGrid extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      editID: null,
      enterEditFlag: false,
      openDeleteModelFlagView: false,
      currentChangedValue: {},
      btnHideFlag: true,
      addActionbtnHideFlag: true,
      loader: false,
      persistenceActionGrid: this.props.persistenceActionGrid,
      persistenceActionGridTemp: this.props.persistenceActionGrid,
      formEditFlag: false,
      showFormView: false,
      formData: {},
      actionCompletionDatePopup: false,
      updatedfield: 0,
      dropdownColumns: [],
      orgUnit: this.getWorkstreamObj(),
    };
    this.gridRef = React.createRef();
  }
  getWorkstreamObj = () => {
    let orgUnit = {};
    mapTree(this.props.organisationUnitList, "children", (item) => {
      if (item.unitId === this.props.dataItem?.organizationUnitId) {
        orgUnit = item;
      }
      return item;
    });
    return orgUnit;
  };
  openActionCompletionDatePopup = () => {
    this.setState({ actionCompletionDatePopup: true });
  };

  closeActionCompletionDatePopup = () => {
    this.setState({ actionCompletionDatePopup: false });
    this.props.refreshRisk();
  };
  componentDidMount = () => {
    this.init();
  };

  init = async () => {
    if (this.gridRef?.current) {
      const gridColumns = this.gridRef.current.columns;
      gridColumns.map((item, i) => {
        item["orderIndex"] = i;
        return item;
      });
      this.props.dataItem.taskActions.map((riskReg) => {
        // if (riskReg.originalCompletionDate) {
        //   riskReg.originalCompletionDate = riskReg.originalCompletionDate
        //     ? moment(new Date(riskReg.originalCompletionDate)).format(
        //         "DD-MMM-YYYY"
        //       )
        //     : null;
        // }
        // if (riskReg.projectedCompletionDate) {
        //   riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
        //     ? moment(new Date(riskReg.projectedCompletionDate)).format(
        //         "DD-MMM-YYYY"
        //       )
        //     : null;
        // }
        // if (riskReg.actualCompletionDate) {
        //   riskReg.actualCompletionDate = riskReg.actualCompletionDate
        //     ? moment(new Date(riskReg.actualCompletionDate)).format(
        //         "DD-MMM-YYYY"
        //       )
        //     : null;
        // }
        // if (riskReg.proximityAlertDate) {
        //   riskReg.proximityAlertDate = riskReg.proximityAlertDate
        //     ? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY")
        //     : null;
        // }
        if (riskReg.originalCompletionDate) {
          riskReg.originalCompletionDate = new Date(
            riskReg.originalCompletionDate
          ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.projectedCompletionDate) {
          riskReg.projectedCompletionDate = new Date(
            riskReg.projectedCompletionDate
          ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.actualCompletionDate) {
          riskReg.actualCompletionDate = new Date(riskReg.actualCompletionDate); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.proximityAlertDate) {
          riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
        }
        if (riskReg.updatedDate) {
          var time = moment(riskReg.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          riskReg.updatedDate = riskReg.updatedDate
            ? moment(new Date(updatedDate)).format("DD-MMM-YYYY")
            : "";
        }
        if (riskReg.createdDate) {
          let time = moment(riskReg.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          riskReg.createdDate = riskReg.createdDate
            ? moment(new Date(createdDate)).format("DD-MMM-YYYY")
            : "";
        }
        if (riskReg.closedDate) {
          let time = moment(riskReg.closedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let closedDate = time;
          riskReg.closedDate = riskReg.closedDate
            ? moment(new Date(closedDate)).format("DD-MMM-YYYY")
            : "";
        }
      });
      // await this.createDynamicDropdowns(this.props.dataItem.taskActions);

      this.setState({
        persistenceActionGridTemp: gridColumns,
        data: this.props.dataItem.taskActions,
      });
    }
  };
  createDynamicDropdowns = async (products) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (
                !dropdownColumn.find((cf) => cf.fieldName == item.fieldName)
              ) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val =
                  temp.selectedCustomFieldNames &&
                    temp.selectedCustomFieldNames.length > 0
                    ? temp.selectedCustomFieldNames.toString()
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? temp.multiText
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? parseInt(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? new Date(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <GridColumn
            field={item.fieldName}
            title={item.fieldName}
            width={this.getFieldWidth(item.fieldName)}
            editable={false}
            resizable={true}
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };
  getFieldWidth = (cellFieldName) => {
    let width = "200px";
    let res = this.props.persistenceActionGrid?.find(
      (item) => item.field === cellFieldName
    );
    if (res) {
      width = res.width;
    }
    return width;
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.error(err);
    }
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,

            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };
  itemChange = (event) => {
    let changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.data.map((item) =>
      item.taskActionId === event.dataItem.taskActionId
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      data: dataValue,
    });
    //dirty check
    let dirtData = this.state.data.find(
      (item) => changedValue.taskActionId == item.taskActionId
    );
    if (
      dirtData &&
      changedValue[this.state.editField] == dirtData[this.state.editField]
    ) {
      this.exitEdit();
      return;
    } else {
      if (event.field === "ownerName" && event.value) {
        let owner = this.props.ownerListForMitigation.find(
          (item) => item.text === event.value
        );
        changedValue["ownerId"] = owner?.value;
      } else if (event.field === "priorityRankingName" && event.value) {
        let rank = this.props.priorityRankingsList.find(
          (item) => item.text === event.value
        );
        changedValue["priorityRankingId"] = rank?.value;
      }
      this.closeEditandSaveActivity(changedValue);
    }
  };
  handleActulaCompletionDate = (date) => {
    let temp = this.state.currentChangedValue;
    temp["actualCompletionDate"] = date;
    this.setState({
      ...this.state,
      currentChangedValue: temp,
    });
  };
  closeEditandSaveActivity = async (data) => {
    try {
      this.setState({ editID: null, enterEditFlag: false });
      if (!data.taskRegisterId) {
        return;
      }
      var subTaskReq = {};
      for (let field in data) {
        subTaskReq[field] = data[field];
      }
      await this.subTaskUpdate(subTaskReq);
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  updateTaskActionRegisterObject = (taskActionObj) => {
    console.log("taskActionObj", taskActionObj);
  };

  subTaskUpdate = async (taskObj) => {
    try {
      if (!taskObj.taskActionTitle || taskObj.taskActionTitle.trim() === "") {
        toastr.error("The Title field should not be empty.");
        return;
      }
      this.setState({ loader: true });
      taskObj.isClosed =
        taskObj.isClosed === "Closed" || taskObj.isClosed === true
          ? true
          : false;
      taskObj.isApproved =
        taskObj.isApproved === "Yes" || taskObj.isApproved === true
          ? true
          : false;
      if (taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === true && !taskObj.actualCompletionDate) {
        this.setState({ loader: false });
        this.openActionCompletionDatePopup();
        return;
      }
      if (taskObj.inEdit === "percentageCompletion" && taskObj.percentageCompletion >= 100 && !taskObj.actualCompletionDate) {
        this.setState({ loader: false });
        this.openActionCompletionDatePopup();
        return;
      }
      if (
        taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === false &&
        taskObj.percentageCompletion >= 100
      ) {
        taskObj.percentageCompletion = 0;
      }

      if (
        taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === false &&
        taskObj.actualCompletionDate
      ) {
        taskObj.actualCompletionDate = null;
      }

      if (taskObj.percentageCompletion >= 100) {
        taskObj.isClosed = true;
        // taskObj.actualCompletionDate = new Date();
      }
      if (
        taskObj.percentageCompletion >= 100 &&
        !taskObj.actualCompletionDate
      ) {
        taskObj.isClosed = true;
        taskObj.actualCompletionDate = new Date();
      }

      if (taskObj.actualCompletionDate) {
        taskObj.isClosed = true;
      }

      if (taskObj.originalCompletionDate && !taskObj.projectedCompletionDate) {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }

      if (taskObj.projectedCompletionDate && !taskObj.originalCompletionDate) {
        taskObj.originalCompletionDate = taskObj.projectedCompletionDate;
      }

      if (taskObj.inEdit == "originalCompletionDate") {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if (taskObj.isClosed === false) {
        taskObj.actualCompletionDate = null;
      }
      taskObj.alertStakeHolders = this.processInput(taskObj.alertStakeHolders);
      taskObj.proximityAlertDate = taskObj.proximityAlertDate
        ? moment(taskObj.proximityAlertDate).format("YYYY-MM-DD")
        : null;
      taskObj.originalCompletionDate = taskObj.originalCompletionDate
        ? moment(taskObj.originalCompletionDate).format("YYYY-MM-DD")
        : null;
      taskObj.projectedCompletionDate = taskObj.projectedCompletionDate
        ? moment(taskObj.projectedCompletionDate).format("YYYY-MM-DD")
        : null;
      taskObj.actualCompletionDate = taskObj.actualCompletionDate
        ? moment(taskObj.actualCompletionDate).format("YYYY-MM-DD")
        : null;

      let response = await Api.addTaskAction(taskObj);
      if (response.status === 200) {
        this.setState({ loader: false, updatedfield: taskObj.taskActionId });
        // this.props.refreshRisk();
        this.closeActionCompletionDatePopup()
      } else {
        toastr.error(response.message);
        this.setState({ loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  addRecord = () => {
    this.setState({ ...this.state, showFormView: true });
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
          ref: (td) => {
            const input = td && td.querySelector("input");
            const activeElement = document.activeElement;

            if (
              !input ||
              !activeElement ||
              input === activeElement ||
              !activeElement.contains(input)
            ) {
              return;
            }

            if (input.type === "checkbox") {
              input.focus();
            } else {
              input.select();
            }
          },
        }
        : {
          onClick: () => {
            this.enterEdit(dataItem, cellField);
          },
          onFocus: () => {
            this.enterEdit(dataItem, cellField);
          },
          tabIndex: "0",
        };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement, props) => {
    const taskActionId = this.state.updatedfield;

    const bgcolor = {
      backgroundColor: "rgba(0, 255, 76, 0.308)",
    };
    const trProps = {
      style: taskActionId == props.dataItem.taskActionId ? bgcolor : null,
      ...trElement.props,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        if (
          this.state.editField == "alertStakeHolders" ||
          this.state.editField === "progressComment"
        ) {
          return;
        }
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: item.taskActionId === dataItem.taskActionId ? field : undefined,
    }));
    this.setState({
      data: dataValue,
      currentChangedValue: dataItem,
      editField: field,
    });
  };

  exitEdit = () => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data: dataValue,
    });
  };

  actionButtonsForViewOnly = (event) => {
    let eventData = event.dataItem;
    return (
      <td className=" editBtns">
        <ul className="actionIcon">
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => this.editFormView(eventData)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
        </ul>
      </td>
    );
  };
  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className=" editBtns">
        {eventData.taskActionNumber ? (
          <ul className="actionIcon">
            <li>
              <a
                title="View"
                className="greenbtn"
                onClick={() => this.editFormView(eventData)}
              >
                <img src={Images.VIEW} width="12" alt="More" />
              </a>
            </li>

            <li>
              <a
                title="Documents"
                className={
                  eventData.documentCount == 0
                    ? "greenbtn roundedBtn icon"
                    : "bluebtn roundedBtn icon"
                }
              >
                <NavLink
                  title="Document"
                  className={
                    eventData.documentCount == 0
                      ? "greenbtn icon"
                      : "bluebtn icon"
                  }
                  to={`/${secureLocalStorage.getItem(
                    "loggedClient"
                  )}/${secureLocalStorage.getItem(
                    "tenantKey"
                  )}/home/documents/taskactiondocs/${eventData.taskActionId}`}
                >
                  <img
                    src={
                      eventData.documentCount == 0
                        ? Images.DOCUMENT
                        : Images.DOCUMENTBLUE
                    }
                    width="12"
                    alt="Document"
                  />
                </NavLink>
              </a>
            </li>
            <li>
              <a
                title="Remove"
                onClick={() => this.openDeletePopup(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.TRASH} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        ) : (
          ""
        )}
      </td>
    );
  };
  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      taskActionId: data.taskActionId,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  deleteTaskAction = async () => {
    try {
      var requestParams = {
        taskActionId: this.state.taskActionId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteTaskAction(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.props.refreshRisk();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  onColumnReorder = (event) => {
    // if (event.end) {
    try {
      let req = {
        persistenceDetails: JSON.stringify(event.target.columnResize.columns),
        WorkstreamId: this.props.dataItem.organizationUnitId,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        screenName: "TaskAction",
      };
      Api.addTaskPersistence(req);
      this.props.refreshPersistence(event.target.columnResize.columns);
    } catch (err) {
      console.log(err);
    }
    // }
  };
  onColumnReorderHome = (event) => {
    // if (event.end) {
    try {
      let req = {
        persistenceDetails: JSON.stringify(event.target.columnResize.columns),
        WorkstreamId: null,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        screenName: "ACTIVITY-EXPAND-HOME",
      };
      Api.addTaskPersistence(req);
      this.props.refreshPersistence(event.target.columnResize.columns);
    } catch (err) {
      console.log(err);
    }
    // }
  };
  onColumnResizeHome = (event) => {
    if (event.end) {
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          screenName: "ACTIVITY-EXPAND-HOME",
        };
        Api.addTaskPersistence(req);
        this.props.refreshPersistence(event.target.columnResize.columns);
      } catch (err) {
        console.log(err);
      }
    }
  };
  mergeAndUpdateArrays = (array1, array2) => {
    // Create a Set of indexes present in array2
    const array2Values = new Set(array2.map((item) => item.field));

    // Loop through array1 and push missing items into array2
    array1.forEach((item) => {
      if (!array2Values.has(item.field)) {
        array2.push(item);
      }
    });

    // Sort array2 by index
    array2.sort((a, b) => a.orderIndex - b.orderIndex);
    return array2;
  };
  onColumnResize = (event) => {
    if (event.end) {
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: this.props.dataItem.organizationUnitId,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          screenName: "TaskAction",
        };
        Api.addTaskPersistence(req);
        this.props.refreshPersistence(event.target.columnResize.columns);
      } catch (err) {
        console.log(err);
      }
    }
  };

  getReductionTitle = (temp) => {
    try {
      if (this.props.dataItem.isOpportunity === "Opportunity") {
        return "Increase in Probability (%)";
      } else {
        return "Reduction in Probability  (%)";
      }
    } catch (err) {
      return "Probability";
    }
  };
  isHiddenRiskColumn = (field) => {
    return this.props.selectedActivitiesColumnFields?.some(
      (item) => item.fieldName === field
    );
  };
  getGridColum = (columns) => {
    let field = columns.field;
    let title = columns.title;
    let width = columns.width;
    let isHidden = this.isHiddenRiskColumn(field);

    let currency = secureLocalStorage.getItem("currency");
    let effortUnitName = this.state.orgUnit?.effortUnitName || "Days";
    if (!field) {
      return;
    } else if (field === "taskActionNumber" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          locked={true}
        />
      );
    } else if (field === "isApproved" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskApproved
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "taskActionTitle" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          locked={true}
          cell={(props) => (
            <TaskTitle
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "taskActionDescription" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDescription
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "cost" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(currency) ? title : title + " (" + currency + ")"
          }
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskCost
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "effort" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(effortUnitName)
              ? title
              : title + " (" + effortUnitName + ")"
          }
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskEffort
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "percentageOnTrack" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskPercentageOnTrack
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "percentageCompletion" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskPercentageCompletion
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "priorityRankingName" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <PriorityRank
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
              priorityRankingsList={this.props.priorityRankingsList}
            />
          )}
        />
      );
    } else if (field === "priorityScore" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
        />
      );
    } else if (field === "originalCompletionDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskOriginalCompDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "projectedCompletionDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskProjectedComDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "actualCompletionDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskActualCompDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "proximityAlertDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskProximityAlertDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "delayConsequence" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "alertStakeHolders" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskAlertStakeholders
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.closeEditandSaveActivity}
              exitEdit={this.exitEdit}
              dropDownData={
                this.props.stackeHolderList ? this.props.stackeHolderList : []
              }
            />
          )}
        />
      );
    } else if (field === "alertDescription" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskAlertDescription
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "ownerName" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskOwner
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
              ownerList={
                this.props.ownerListForMitigation
                  ? this.props.ownerListForMitigation
                  : []
              }
            />
          )}
        />
      );
    } else if (field === "createdDate" && !isHidden) {
      return (
        <GridColumn
          field="createdDate"
          title="created Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
        />
      );
    } else if (field === "createdByName" && !isHidden) {
      return (
        <GridColumn
          field="createdByName"
          title="Created By"
          width={width}
          resizable={true}
          editable={false}
        />
      );
    } else if (field === "updatedDate" && !isHidden) {
      return (
        <GridColumn
          field="updatedDate"
          title="updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
        />
      );
    } else if (field === "updatedByName" && !isHidden) {
      return (
        <GridColumn
          field="updatedByName"
          title="Updated By"
          width={width}
          resizable={true}
          editable={false}
        />
      );
    } else if (field === "closedDate" && !isHidden) {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
        />
      );
    } else if (field === "isClosed" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskStatus
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "departments" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "externalStatus" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "weeklyReport" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "progressComment" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskActivityProgressPopup
              {...props}
              onEditCell={this.enterEdit}
              exitEdit={this.exitEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "customFields") {
      return this.state.dropdownColumns;
    } else {
      let cf = this.state.dropdownColumns.find(
        (item) => field === item.props.field
      );
      if (cf) {
        return cf;
      }
    }
  };

  notavailable = () => {
    return (
      <td className="k-grid-content-sticky editBtns">
        <ul className="actionIcon">
          <span>NA</span>
        </ul>
      </td>
    );
  };

  closeRiskFormView = (flag) => {
    this.setState({
      ...this.state,
      showFormView: false,
      formData: {},
      formEditFlag: false,
    });
    if (flag == "REFRESH") {
      this.props.refreshRisk();
    }
  };

  addRiskDataFromForm = () => {
    this.props.refreshRisk();
  };

  editFormView = (dataItem) => {
    try {
      this.setState({
        ...this.state,
        showFormView: true,
        formData: dataItem,
        formEditFlag: true,
      });
    } catch (err) {
      console.error(err);
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }
  render() {
    const data = this.props.dataItem.taskActions
      ? this.props.dataItem.taskActions
      : {};
    const editRoleFlag =
      data.isOpen == false || data.isOpen == "No" ? false : true;
    return (
      <div className="riskReportMitigation" id="home-riskMitigation">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        {this.state.showFormView === true ? (
          <TaskActionRegisterFormView
            formEditFlag={this.state.formEditFlag}
            formData={this.state.formData}
            showFormView={this.state.showFormView}
            orgUnit={this.state.orgUnit}
            closeRiskFormView={this.closeRiskFormView}
            addRiskDataFromForm={this.addRiskDataFromForm}
            dropDownData={
              this.props.stackeHolderList ? this.props.stackeHolderList : []
            }
            ownerListForRisk={
              this.props.ownerListForMitigation
                ? this.props.ownerListForMitigation
                : []
            }
            priorityRankingsList={
              this.props.priorityRankingsList
                ? this.props.priorityRankingsList
                : []
            }
            taskDetails={this.props.dataItem}
            selectedActivitiesColumnFields={this.props.selectedActivitiesColumnFields}
            role={this.props.dataItem.role}
            {...this.props}
          />
        ) : (
          ""
        )}

        <Grid
          ref={this.gridRef}
          data={this.state.data}
          cellRender={this.cellRender}
          rowRender={this.rowRender}
          reorderable={this.state.data.length == 0 ? false : true}
          resizable={this.state.data.length == 0 ? false : true}
          editField="inEdit"
          onItemChange={this.itemChange}
          onColumnReorder={this.props.pageName === "Home" ? this.onColumnReorderHome : this.onColumnReorder}
          onColumnResize={this.props.pageName === "Home" ? this.onColumnResizeHome : this.onColumnResize}
        >
          {this.props.dataItem.role !== "View Only" &&
            this.props.dataItem.role !== "Standard User" ? (
            <GridToolbar>
              <div>
                {this.state.addActionbtnHideFlag &&
                  this.props.dataItem.taskRegisterId && (
                    <>
                      <button
                        title="Add new"
                        className="k-button k-primary addRisks"
                        id="action-id"
                        onClick={this.addRecord}
                      >
                        Add Activity
                      </button>
                    </>
                  )}
              </div>
            </GridToolbar>
          ) : (
            ""
          )}

          {this.props.dataItem.role == "View Only" ||
            this.props.dataItem.role == "Standard User" ? (
            <GridColumn
              cell={this.actionButtonsForViewOnly}
              width="85px"
              filterable={false}
            />
          ) : (
            <GridColumn
              cell={this.actionButtons}
              width="85px"
              filterable={false}
            />
          )}
          {this.props.persistenceActionGrid &&
            this.props.persistenceActionGrid.map((columns) =>
              this.getGridColum(columns, editRoleFlag)
            )}
        </Grid>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this Activity?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.deleteTaskAction()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup
          show={this.state.actionCompletionDatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont actualCompPopup">
            <h3>Activity Update</h3>
            <div className="labelBlock">
              <label className="fieldLabel1">
                <span className="fieldTitle">Activity Title :</span>
                {this.state.currentChangedValue?.taskActionTitle}
              </label>

              <label className="fieldLabel2">
                <span className="fieldTitle">Activity Number : </span>
                {this.state.currentChangedValue?.taskActionNumber}
              </label>
            </div>
            <label className="fieldLabel3">
              <span className="fieldTitle">Actual Completion Date</span>
            </label>

            <DatePicker
              format="dd-MMM-yyyy"
              onChange={(e) => this.handleActulaCompletionDate(e.target.value)}
            />

            <div className="btnCont">
              <button
                onClick={() =>
                  this.closeEditandSaveActivity(
                    this.state.currentChangedValue
                  )
                }
                type="button"
                className="deleteBtn"
              >
                Submit
              </button>
              <button
                onClick={this.closeActionCompletionDatePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
